import { useQuery } from 'react-query';

import { metaDataQueryKeys } from '../QueryKeys';
import useApiHelper from '../../hooks/useApiHelper';
import { IDefaultResponseWithData } from '../../types/system/DefaultResponse';
import { ChatHistory } from '../../types/Orbit/Chat';

export default function useMetadata() {
  const { get } = useApiHelper();

  const list = useQuery({
    queryKey: metaDataQueryKeys.all(),
    queryFn: () =>
      get<IDefaultResponseWithData<ChatHistory>>('/v1/chat').then(
        (res) => res.data.data
      ),
  });

  return {
    list,
  };
}
